import { Injectable } from '@angular/core';
import { ListCompany } from '../models/list-company.model';
import { ListWorksite } from '../models/list-worksite.model';
import { SearchParams } from '../models/search-params.model';
import { SearchResult } from '../models/search-result.model';
import { SearchResultsRepository } from '../repositories/search-result.repository';

@Injectable({ providedIn: 'root' })
export class SearchResultsCommand {
  constructor(private searchResultsRepository: SearchResultsRepository) {}

  setActive(companyId: string) {
    this.searchResultsRepository.setActive(companyId);
  }

  unsetActive() {
    // eslint-disable-next-line unicorn/no-null
    this.searchResultsRepository.setActive(null);
  }

  set(searchResult: SearchResult<ListCompany>) {
    this.searchResultsRepository.setProps({
      extendedWorksites: [],
      bisnodeNotResponding: false,
      totalSearchAmount: searchResult ? searchResult.totalAmount : -1,
    });
    this.searchResultsRepository.set(searchResult ? searchResult.result : []);
  }

  setCompany(company: ListCompany) {
    this.searchResultsRepository.set([company]);
  }

  updateCompany(id: string, worksites: ListWorksite[]) {
    this.searchResultsRepository.update(
      id,
      (draft) => (draft.worksites = worksites),
    );
  }

  // UI
  updateIsSearching(isSearching: boolean) {
    this.searchResultsRepository.setProps({ isSearching });
  }

  updateSearchParams(searchParams: SearchParams) {
    this.searchResultsRepository.setProps({ searchParams });
  }

  updateActiveCompany(company: ListCompany) {
    this.searchResultsRepository.setActive(company.providerId);
  }

  updateShowAllWorksitesParameter(
    id: string,
    showAllWorksitesParameter: boolean,
  ) {
    this.searchResultsRepository.updateUi(
      id,
      (draft) => (draft.showAllWorksitesParameter = showAllWorksitesParameter),
    );
  }

  updateIsCollapsedParameter(id: string, isCollapsed: boolean) {
    this.searchResultsRepository.updateUi(
      id,
      (draft) => (draft.isCollapsed = isCollapsed),
    );
  }
}
